import React, { useState, useEffect } from "react";
import AnimatedPageContainer from "../../../../assets/containers/AnimatedPageContainer";
import KhazaneListElement from "./KhazaneListElement";
import NoResultAlter from "../../../../assets/components/UI/NoResultAlter";
import appApi from "../../../../assets/utils/AppApi";
import Loading from "../../../../assets/containers/loadingDialog";
import { motion } from "framer-motion";

const container = {
  hidden: { opacity: 1, scale: 0 },
  visible: {
    opacity: 1,
    scale: 1,
    transition: {
      delayChildren: 0.3,
      staggerChildren: 0.2,
    },
  },
};

const itemContainer = {
  hidden: { y: 20, opacity: 0 },
  visible: {
    y: 0,
    opacity: 1,
  },
};

export default function MatchKhazaneh() {
  const [archives, setArchives] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    getScores();
  }, []);

  const getScores = () => {
    setLoading(true);
    appApi
      .get("/quiz/getarchived")
      .then(({ data }) => {
        setArchives(data.quizzes);
        setLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setLoading(false);
      });
  };

  return (
    <div className="customContainer">
      <AnimatedPageContainer>
        <div className="my-4">
          {loading ? (
            <Loading
              size={30}
              className={"w-100 d-flex justify-content-center py-5 my-5"}
            />
          ) : archives.length !== 0 ? (
            <motion.div
              variants={container}
              initial="hidden"
              animate="visible"
              className="w-100"
            >
              {archives.map((test, index) => (
                <motion.div variants={itemContainer} key={index}>
                  <KhazaneListElement quiz={test} />
                </motion.div>
              ))}
            </motion.div>
          ) : (
            <NoResultAlter className={"w-100  py-5 my-5"} />
          )}
        </div>
      </AnimatedPageContainer>
    </div>
  );
}
